module.exports = __webpack_public_path__ + "img/Icon - Internet.73cd00fc.png";